const ACTION_TYPES = {
    API_PENDING: 'SERVICE_PENDING',
    API_SUCCESS: 'SERVICE_SUCCESS',
    API_ERROR: 'SERVICE_ERROR',
    API_LOADER_START: 'API_LOADER_START',
    API_LOADER_SUCCESS: 'API_LOADER_SUCCESS',
    API_LOADER_ERROR: 'API_LOADER_ERROR',
    USER_PENDING: 'USER_PENDING',
    USER_SUCCESS: 'USER_SUCCESS',
    USER_ERROR: 'USER_ERROR',
    LOGOUT: 'LOGOUT',
};
export default ACTION_TYPES;
